import Vue from 'vue';
import Dictionary from "@/types/Dictionary";
import RegistrationPage from "../RegistrationPage.vue";
import { API_URL } from "@/App.settings";
import axios from "axios";
import { RegistrationState } from "./RegistrationState";
import { RegStateErrorExpired } from "./RegStateErrorExpired";
import { RegStateInit } from "./RegStateInit";

/** Etat : Traitement de l'arrivée sur la page */
export class RegStateStart extends RegistrationState {

    /** Constructeur de démarage réservé à start */
    constructor(context: RegistrationPage) {
        /** Aucun previous car c'est le premier noeud du graph */
        super(null);
        this.context = context;
        this.token = "";
        this.analyseToken = null;
    }
    
    /** Lance l'état suivant */
    public async Next(): Promise<void> {
        await this.context.$store.dispatch("ShowLoadingMask", this.context.$t('LoadingRegisterInformation'));

        /** Récupération du token employé pour l'enregistrement ou le changement de mots de passe */
        this.token = this.context.$route.params.validationToken;

        /** Trie le gros des tokens ayant une apparence frauduleuse évidente, sans pour autant dévoiler la structure normale d'un token */
        if(this.token.length < 11)
            this.context.$router.push({ name: 'Connexion' });

        /** Le token est crypté, il doit être décrypté par le serveur */
        let args: Dictionary<any> = {
            registrationToken: this.token
        };

        /** Effectue une vérification du token et une initialisation du formulaire */
        await axios.post(API_URL + "User/RegistrationCheck", args).then(async (response) => {
            if(response && response.data)
            {
                /** Stocke les informations */
                this.analyseToken = response.data;

                /** Intialisation des champs de saisie */
                if(this.analyseToken.Expired){
                    this.context.TransitionTo(new RegStateErrorExpired(this))
                }else{
                    this.context.TransitionTo(new RegStateInit(this))
                }

                /** Indique si la politique de sécurité doit être appliquée */
                this.context.HasPasswordPolicy = this.analyseToken.HasPasswordPolicy;
                this.context.MinCharLength = this.analyseToken.CharLength;
                this.context.MinDigit = this.analyseToken.CharDigit;
                this.context.MinSpecialChar = this.analyseToken.CharSpecial;
                this.context.MinUpperCase = this.analyseToken.CharUpperCase;
                this.context.ListSpecialChar = this.analyseToken.CharSpecialList;
            }
        }).catch((err) =>{
            console.error(err);
            // Pour éviter une éventuel indication sur le contenu de notre base d'utilisateur. nous indiquons un token expiré par défaut
            this.context.TransitionTo(new RegStateErrorExpired(this))
        }).finally(async () =>{
            await this.context.$store.dispatch("HideLoadingMask", {});
        })
        await this.context.Next();
    }
}